<template>
  <div class="block-subscribe-form py-8 lg:py-16" :class="background">
    <div class="container mx-auto w-full max-w-screen-xl">
      <div class="bg-[--color-primary-500] rounded-xl flex flex-col md:flex-row">
        <div class="w-full md:w-1/2 flex justify-center flex-col p-4 md:p-8 lg:p-10 lg:pr-20">
          <div class="title mb-4 text-xl text-white font-bold">{{ title }}</div>

          <div class="subtitle text-white text-lg mb-10">{{ subtitle }}</div>

          <div class="flex flex-col sm:flex-row w-full mb-4">
            <VcInput
              v-model="email"
              type="email"
              class="w-full sm:max-w-[300px] mr-2 mb-2 sm:mb-0"
              :placeholder="placeholder"
            />

            <VcButton size="md" color="secondary" :disabled="loading" @click="submitForm">
              {{ loading ? "Bezig..." : buttonText }}
            </VcButton>
          </div>

          <div v-if="success" class="text-[--color-secondary-500]">{{ $t("custom.newsletter.subscribed") }}</div>

          <div v-if="error" class="text-danger-500">
            {{ $t("common.messages.email_is_not_correct") }}
          </div>
        </div>
        <div class="w-full md:w-1/2">
          <VcImage
            :src="newsletterImage ?? 'deklok-truck.jpg'"
            class="max-h-[320px] w-full h-full object-cover rounded-b-lg md:rounded-r-lg"
            lazy
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useThemeContext } from "@/core/composables";
import { MAILCHIMP_URL_PROPERTY } from "@/core/constants";

export interface IProps {
  background?: string;
  title?: string;
  subtitle?: string;
  placeholder?: string;
  checkboxText?: string;
  buttonText?: string;
  newsletterImage?: string;
}

defineProps<IProps>();

const email = ref("");
const loading = ref(false);
const success = ref(false);
const error = ref(false);
const { themeContext } = useThemeContext();

const mailchimpUrl = computed(() => {
  const dpArray = themeContext.value.dynamicProperties ?? [];
  return dpArray.find((item) => item.name && item.name === MAILCHIMP_URL_PROPERTY)?.value ?? "";
});

async function submitForm() {
  if (!mailchimpUrl.value) {
    return;
  }
  success.value = false;

  if (!email.value) {
    error.value = true;
    return;
  }

  loading.value = true;

  try {
    await fetch(mailchimpUrl.value as string, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        EMAIL: email.value,
      }).toString(),
    });

    success.value = true;
    error.value = false;
    email.value = "";
  } catch (err) {
    error.value = true;
  } finally {
    loading.value = false;
  }
}
</script>
